const INITIAL_STATE = {
  dadosRequerente: null,
  protocoloPat: null,
  servicoSelecionado: null,
  camposAdicionaisPericia: null,
  disponibilidade: null,
  vaga: null,
  remarcarAgendamento: null,
  idRequerimentoAnterior: null,
  retornoRequerimento: null,
  siglaServico: null,
  esperandoSolicitacao: null,
  alerta: null,
  idUOMantenedora: null,
  agendarProrrogacaoSegundoMomento: null,
  voltarAgendamento: null,
  dut: null,
  dutInformadaRequerente: null,
  mostrarCarregando: false,

  // Itens da Prorrogação
  numeroProtocoloTarefaINSS: null,
  dataEntradaRequerimento: null,
  idUOConcessoraMantenedora: null,
  idUOConcessora: null,
  idUOMantenedora: null,
  origemSolicitacao: null,
  sistemaSolicitante: null,
  tipoPericia: null,
  dataCessacaoBeneficio: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'REQUERIMENTO_INICIAR_AGENDAR_PERICIA':
      return { ...state, alerta: {}, remarcarAgendamento: false, esperandoSolicitacao: true, voltarAgendamento: action.payload }
    case 'REQUERIMENTO_INICIAR_REMARCAR_AGENDAMENTO_PERICIA':
      return { ...state, alerta: {}, siglaServico: action.siglaServico, remarcarAgendamento: true, esperandoSolicitacao: true }
    case 'REQUERIMENTO_SOLICITAR_CAMPOS_ADICIONAIS':
      return { ...state, alerta: {}, esperandoSolicitacao: true };
    case 'REQUERIMENTO_RECEBER_CAMPOS_ADICIONAIS':
      return { ...state, camposAdicionaisPericia: action.data, esperandoSolicitacao: false };
    case 'PERICIA_RECEBER_SERVICO':
      return { ...state, alerta: {}, servicoSelecionado: action.data };
    case 'REQUERIMENTO_SET_DISPONIBILIDADE':
      return { ...state, disponibilidade: action.data };
    case 'PERICIA_SET_REQUERENTE':
      return {
        ...state,
        dadosRequerente: action.data.dadosRequerente,
        protocoloPat: action.data.protocoloPat,
        idUOMantenedora: action.data.idUOMantenedora,
        dut: action.data.dut,
        dutInformadaRequerente: action.data.dutInformadaRequerente,
        servicoSelecionado: action.data.servicoSelecionado,
        sistemaSolicitante: action.data.sistemaSolicitante,
        origemSolicitacao: action.data.origemSolicitacao,
        camposAdicionaisPericia: action.data.camposAdicionaisPericia,
        dataCessacaoBeneficio: action.data.dataCessacaoBeneficio,
        tipoPericia: action.data.tipoPericia
      };
    case 'PERICIA_SET_ID_REQUERIMENTO':
      return { ...state, idRequerimentoAnterior: action.id };
    case 'REQUERIMENTO_ERROR':
      return { ...state, alerta: { message: action.data, severity: 'error' }, esperandoSolicitacao: false };
    case 'PERICIA_SET_CAMPOS_ADICIONAIS':
      return { ...state, camposAdicionaisPericia: action.data };
    case 'PERICIA_ENVIAR_REQUERIMENTO':
      return { ...state, alerta: null, esperandoSolicitacao: true };
    case 'PERICIA_RETORNO_REQUERIMENTO':
    case 'PERICIA_PEDIDO_PRORROGACAO_SUCESSO':
      return { ...state, retornoRequerimento: action.data, esperandoSolicitacao: false };
    case 'PERICIA_ERRO_REQUERIMENTO':
    case 'PERICIA_PEDIDO_PRORROGACAO_ERRO':
      return { ...state, alerta: { message: action.data, severity: 'error' }, esperandoSolicitacao: false };
    case 'PERICIA_PROCESSAR_VAGA':
      return { ...state, alerta: null, esperandoSolicitacao: true };
    case 'PERICIA_RETORNO_VAGA':
      return { ...state, vaga: action.data[0], esperandoSolicitacao: false };
    case 'PERICIA_ERRO_VAGA':
      return { ...state, alerta: {}, esperandoSolicitacao: false };
    case "PERICIA_ALTERAR_CAMPO_ADICIONAL": {
      return {
        ...state,
        camposAdicionaisPericia: action.payload
      };
    }
    case 'PERICIA_PRORROGACAO_INICIAR':
      return { ...state, esperandoSolicitacao: false, alerta: {}, servicoSelecionado: action.servicoSelecionado, agendarProrrogacaoSegundoMomento: action.agendarProrrogacaoSegundoMomento };
    case 'PERICIA_PRORROGACAO_EXIBIR_ALERTA':
      return { ...state, esperandoSolicitacao: false, alerta: action.payload }
    case 'PERICIA_PRORROGACAO_FECHAR_ALERTA':
      return { ...state, esperandoSolicitacao: false, alerta: {} };
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_COMPROVANTE':
      return { ...state, esperandoSolicitacao: true }
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_COMPROVANTE_SUCESSO':
      return { ...state, esperandoSolicitacao: false }
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_COMPROVANTE_ERRO':
      return { ...state, esperandoSolicitacao: false }
    case 'REQUERIMENTO_PERICIA_MOSTRAR_CARREGANDO':
      return { ...state, mostrarCarregando: action.payload }
    default:
      return state;
  }

}